import { gql } from "@apollo/client";

export const UPDATE_STATUS = gql`
  mutation UpdateStatus($masjidId: String!, $input: UpdateStatusInput!) {
    updateStatus(masjidId: $masjidId, input: $input)
  }
`;
